var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[_vm.buttonClass],domProps:{"textContent":_vm._s(_vm.buttonText)},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }